import React from "react"
import "./Section.01.Subject.css"

export default function SubjectSection(params) {

    const {rescue} = params
    const userAgent = navigator.userAgent.toLowerCase()
    const androidChrome = userAgent.includes("android") && userAgent.includes("chrome")


    return <li className="accordion">
  		<input type="checkbox" className="accordion" id="acc-subject"/>
  		<label className="accordion" htmlFor="acc-subject">Podaci o povređenom</label>
  		<section className="accordion">
      		<div className="field">
      		    <label htmlFor="subject/given_name" className="above">Ime</label>
          		<input type="text" value={rescue.rescue.subject?.given_name || ''} id="subject/given_name" placeholder="npr. Marko" onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
          	</div>
  		  
  		    <div className="field">
          		<label htmlFor="subject/family_name" className="above">Prezime</label>
          		<input type="text" value={rescue.rescue.subject?.family_name || ''} id="subject/family_name" placeholder="npr. Jovanović" onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
          	</div>
  		  
  		    <div className="field gender">
      		    <label className="above">Pol</label>
      		    <div id="gender-fields">
      		        <input type="radio" id="input-male" name="gender" value="male"
              		       onChange={() => rescue.setField("subject/gender", "male")} checked={rescue.rescue.subject?.gender === 'male'}
                  		   disabled={rescue.isReadOnly}/><label className="gender" htmlFor="input-male">Muško</label>
      		        <input type="radio" id="input-female" name="gender" value="female"
          		           onChange={() => rescue.setField("subject/gender", "female")} checked={rescue.rescue.subject?.gender === 'female'}
          		           disabled={rescue.isReadOnly}/><label className="gender" htmlFor="input-female">Žensko</label>
      			    <button className="btn btn-light btn-sm" onClick={() => rescue.setField("subject/gender", null)} disabled={rescue.isReadOnly}>
          			    <i className="fas fa-times no-margin"></i>
      			    </button>
      			</div>
  		    </div>
  		  
  		    <div className="field">
      		    <label htmlFor="subject/birth_date" className="above">Datum rođenja
          		    {androidChrome && <div className="hint">Godinu možete promeniti tako što kliknete na nju</div>}
      		    </label>
             		<input type="date" readOnly={rescue.isReadOnly} value={rescue.rescue.subject?.birth_date || ''} id="subject/birth_date" className="datetime" onChange={rescue.onChange}/>
             	</div>

              <div className="field">
      		    <label htmlFor="subject/birth_place" className="above">Mesto rođenja</label>
      		    <input type="text" readOnly={rescue.isReadOnly} value={rescue.rescue.subject?.birth_place || ''} id="subject/birth_place" placeholder="npr. Beograd" onChange={rescue.onChange}/>
  		    </div>
  		  
  		    <div className="field">
      		    <label htmlFor="subject/address" className="above">Adresa stanovanja</label>
      		    <input type="text" readOnly={rescue.isReadOnly} value={rescue.rescue.subject?.address || ''} id="subject/address" placeholder="npr. Ivana Ribara 54, 11070 Beograd" onChange={rescue.onChange}/>
  		    </div>
  		  
  		    <div className="field">
      		    <label htmlFor="subject/phone_number" className="above">Kontakt telefon</label>
      		    <input type="text" readOnly={rescue.isReadOnly} value={rescue.rescue.subject?.phone_number || ''} id="subject/phone_number" placeholder="npr. 063 555 1234" onChange={rescue.onChange}/>
  		    </div>
  		</section>
  	  </li>

}